import { motion } from 'motion/react';

const SEGMENT_COLORS: Record<number, string> = {
  0: '#2a2a30',
  1: '#E6453B',
  2: '#E6B53B',
  3: '#9DCD5A',
  4: '#3DD68C',
};

interface PasswordStrengthMeterProps {
  score: number;
}

export function PasswordStrengthMeter({ score }: PasswordStrengthMeterProps) {
  const filledColor = SEGMENT_COLORS[Math.min(Math.max(score, 0), 4)];
  return (
    <div className="mt-2 flex h-1 gap-1">
      {[0, 1, 2, 3].map((i) => {
        const filled = i < score;
        return (
          <motion.span
            key={i}
            initial={false}
            animate={{ backgroundColor: filled ? filledColor : SEGMENT_COLORS[0] }}
            transition={{ duration: 0.25 }}
            className="flex-1 rounded-full"
          />
        );
      })}
    </div>
  );
}
